import {
  WidgetDouble,
  WidgetDoubleFree,
  WidgetCarousel,
  WidgetAction,
  WidgetActionGlobalView,
  WidgetActionRanking,
  WidgetBadge,
  WidgetEdito,
  WidgetPoints,
  WidgetVideo,
  WidgetGame,
} from './types';

export const WIDGETS_TYPE: {
  DOUBLE: WidgetDouble;
  DOUBLE_FREE: WidgetDoubleFree;
  CAROUSEL: WidgetCarousel;
  ACTION: WidgetAction;
  ACTION_GLOBAL_VIEW: WidgetActionGlobalView;
  ACTION_RANKING: WidgetActionRanking;
  BADGE: WidgetBadge;
  EDITO: WidgetEdito;
  POINTS: WidgetPoints;
  VIDEO: WidgetVideo;
  GAME: WidgetGame;
} = Object.freeze({
  DOUBLE: 'WidgetDouble',
  DOUBLE_FREE: 'WidgetDoubleFree',
  CAROUSEL: 'WidgetCarrousel',
  ACTION: 'WidgetAction',
  ACTION_GLOBAL_VIEW: 'WidgetActionGlobalView',
  ACTION_RANKING: 'WidgetActionRanking',
  BADGE: 'WidgetBadge',
  EDITO: 'WidgetEdito',
  POINTS: 'WidgetPoints',
  VIDEO: 'WidgetVideo',
  GAME: 'WidgetGame',
});
